// extracted by mini-css-extract-plugin
export default {"label":"label__PAUC9YifyhEbg7SyefEA","select":"select__ENDvVPVHeh3MvZ0rKqOf"};